import { render, staticRenderFns } from "./SelectChatOfferUserModal.vue?vue&type=template&id=2819f3a6&scoped=true&"
import script from "./SelectChatOfferUserModal.vue?vue&type=script&lang=js&"
export * from "./SelectChatOfferUserModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectChatOfferUserModal.vue?vue&type=style&index=0&id=2819f3a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2819f3a6",
  null
  
)

export default component.exports